import { type CSSProperties, type ReactNode } from "react"

import styles from "./text-stagger.module.css"

const STAGGER_MS = 140

export const textStaggerGroupClass = styles.group

export function TextStagger({
  index,
  className,
  children,
}: {
  index: number
  className?: string
  children: ReactNode
}) {
  const style = {
    animationDelay: `${index * STAGGER_MS}ms`,
  } satisfies CSSProperties

  return (
    <div
      className={className ? `${styles.item} ${className}` : styles.item}
      style={style}
    >
      {children}
    </div>
  )
}
